import {Sort, SortingOptionsValues} from './tableTypes';

interface getInitialPageArgs {
    query: URLSearchParams,
    rowsPerPage: number
}

export const getInitialPage = ({query, rowsPerPage}: getInitialPageArgs) => Number(query.get('offset')) / rowsPerPage || 0;
export const getInitialRowsPerPage = (query: URLSearchParams) => Number(query.get('limit')) ||
    Number(sessionStorage.getItem('rowsPerPage')) ||
    25;
export const getInitialSort = (query: URLSearchParams): Sort => {
    const sortBy = query.get('sortBy') || undefined;
    const sortOrder = query.get('sortOrder') as SortingOptionsValues || undefined;
    return {
        sortBy,
        sortOrder,
    };
};

export * from './tableTypes';
export {default} from './TableContainer';
